module.exports = __webpack_public_path__ + "img/bluesky3100_27.ef5cac4a.jpg";